import notfoundComponent from './notfound.component';

const notfoundModule = angular
  .module('notfound', [])
  .component('notfound', notfoundComponent);

export default notfoundModule;


/** WEBPACK FOOTER **
 ** ./frontend/components/errors/notfound/notfound.js
 **/